import React, { useState, useContext } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import AuthContext from '../context/AuthContext';

const AddProduct = () => {
  const navigate = useNavigate();
  const { isAdmin } = useContext(AuthContext);
  const { branch } = useParams();

  const [name, setName] = useState('');
  const [itemCode, setItemCode] = useState('');
  const [quantity, setQuantity] = useState(0);
  const [image, setImage] = useState(null);
  const [imagePreview, setImagePreview] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  // Redirect if not admin
  if (!isAdmin()) {
    navigate('/');
    return null;
  }

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImage(file);
      setImagePreview(URL.createObjectURL(file));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!name || !itemCode) {
      setError('Name and item code are required');
      return;
    }
    try {
      setLoading(true);
      setError('');
      const formData = new FormData();
      formData.append('name', name);
      formData.append('itemCode', itemCode);
      formData.append('quantity', quantity);
      if (image) {
        formData.append('image', image);
      }
      const token = localStorage.getItem('token');
      const response = await axios.post(`/api/products/${branch}`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data'
        }
      });
      if (response.data.success) {
        alert('Product added successfully');
        navigate(`/${branch}`);
      } else {
        setError(response.data.message || 'Failed to add product');
      }
    } catch (error) {
      console.error('Error adding product:', error);
      setError(error.response?.data?.message || 'Failed to add product');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="card">
      <div className="card-header d-flex justify-content-between align-items-center">
        <h2 className="mb-0">Add New Product</h2>
        <button className="btn btn-secondary" onClick={() => navigate('/')}>
          Cancel
        </button>
      </div>
      
      <div className="card-body">
        {error && (
          <div className="alert alert-danger" role="alert">
            {error}
          </div>
        )}
        
        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label htmlFor="name" className="form-label">Product Name</label>
            <input
              type="text"
              className="form-control"
              id="name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />
          </div>
          
          <div className="mb-3">
            <label htmlFor="itemCode" className="form-label">Item Code</label>
            <input
              type="text"
              className="form-control"
              id="itemCode"
              value={itemCode}
              onChange={(e) => setItemCode(e.target.value)}
              required
            />
          </div>
          
          <div className="mb-3">
            <label htmlFor="quantity" className="form-label">Quantity</label>
            <input
              type="number"
              className="form-control"
              id="quantity"
              value={quantity}
              onChange={(e) => setQuantity(Math.max(0, parseInt(e.target.value) || 0))}
              min="0"
            />
          </div>
          
          <div className="mb-3">
            <label htmlFor="image" className="form-label">Product Image</label>
            <input
              type="file"
              className="form-control"
              id="image"
              accept="image/*"
              onChange={handleImageChange}
            />
            <small className="form-text text-muted">
              If no image is uploaded, the system will look for an image named [itemCode].jpg in the photos directory.
            </small>
          </div>
          
          {imagePreview && (
            <div className="mb-3">
              <label className="form-label">Image Preview</label>
              <div>
                <img 
                  src={imagePreview} 
                  alt="Preview" 
                  className="img-thumbnail" 
                  style={{ maxHeight: '200px' }} 
                />
              </div>
            </div>
          )}
          
          <div className="d-grid">
            <button 
              type="submit" 
              className="btn btn-primary"
              disabled={loading}
            >
              {loading ? 'Adding...' : 'Add Product'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddProduct;
